module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor326"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor333"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor338"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor339"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor342"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor343"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page27",
      "title": "27"
    }
  }), _vm._v("2")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "_idParaDest-6",
      "title": "2 Ancient Christianity in Asia"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor344"
    }
  }), _vm._v("Ancient Christianity in Asia")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    staticClass: "initial-cap"
  }, [_vm._v("E")]), _vm._v("arliest Christianity developed at the intersection of three continents, caught between two major empires, centered on the teachings of one Asian peasant. The early followers of Jesus spread in all directions from the eastern Mediterranean world of the Roman Empire, especially to the East, across the Persian Empire. By the end of the first century, Christians speaking Aramaic, Syriac, Latin, and Greek were found not only in the Roman regions of Asia, but also deep in the Persian (Parthian) Empire. In Roman Asia, Christians were persecuted because of their uncompromising monotheism and therefore their unwillingness to honor the "), _c('i', [_vm._v("genius")]), _vm._v(" of the emperor. By contrast, as Christianity spread into Parthian Asia, Christians had greater freedom. Parthia, even though Zoroastrianism was the dominant religion, had developed a peace based on tolerance of other religions: it became known later as a “Parthian Peace.” This tolerance allowed for Christianity to develop, for Christian refugees from the Roman Empire to find a home, and for other religious people to prosper.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The centers of earliest Asian Christianity that we are aware of were major trading centers along the Silk Road and client kingdoms of Rome and Persia, as well as other political centers: Antioch, Aleppo, Edessa (Urfa), Nisibis, Kirkuk, Arbela, Seleucia-Ctesiphon, and by the seventh century, Kashgar, Samarqand, Almalik, and even Chang’an (Xian) in China. Thus, by the time Christianity had spread to Scandinavia (less than two thousand miles) it had already spread to the heart of China (over four thousand miles), had grown, developed, been persecuted, and declined. In fact there were bishops across central Asia before the czar of Russia sent his delegation to learn about Christianity in Constantinople. Asia had priority in the spread of Christianity in its first millennium.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor346"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor347"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor348"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor349"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor350"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor351"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor352"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor353"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor354"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor355"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor356"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor357"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor358"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor359"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor360"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor361"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor362"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor363"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page28",
      "title": "28"
    }
  }), _vm._v("However, the history of the very earliest communities outside the Roman Empire is shrouded in mystery and filled with half-converted saints and zealous ascetics. Asian Christianity did not develop a unified ecclesial order until the early fifth century. The vast territory, severe persecutions beginning in the third century, and the influx of refugees and Roman “heretics” gave a unique diversity to Asian Christianity that was not known in the West. It would be the waves of persecution—from Indian, Chinese, Persian, and Arab rulers—more than the theological diversity that prevented Asian Christianity from having a major influence in Asia until recent times. There has been a pattern to the development of Asian Christianity: ascetic missionaries move into new territories; growth under tolerant rulers; and then sudden changes in fortune under a new regime or dynasty. This pattern was first seen in Persia and India in the early centuries of Asian Christianity, and it has been true through the twentieth century up to the present day.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_15"
    }
  }, [_vm._v("Earliest Asian Christianity")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The earliest followers of Jesus in non-Roman Asia were mostly Semitic peoples who spread the faith through both migration (trade) and intentional apostolic activity. Although no records remain, it is likely that some of the earliest Asian missionaries of Jesus were in Jerusalem at the time of Pentecost and the origin of the Jewish church. Of the Asian pilgrims mentioned in "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Acts+2",
      "target": "_blank"
    }
  }, [_vm._v("Acts 2")]), _vm._v(", three groups would be considered Iranian: those from Parthia (which would probably be northeast Iran today), the Elamites, and the Medes. Mesopotamia, or present-day Iraq and Syria, is also mentioned, so it is likely that some of these earliest converts would have brought the new faith back to their villages. What evidence we do have of early Asian Christianity is sparse. The Odes of Solomon may be the earliest Asian Christian worship book, with hymns, small sermons, and liturgies. However, it is not clear whether all of the Odes were written in Syriac (the language of early Asian Christianity), Greek, or both languages. Neither is it clear whether the Odes came from western Syria (Antioch) or eastern Syria in a location such as Edessa. What the Odes do reveal is an early tradition of a Semitic theological style. Most of the hymns and sermons in Syriac were written in parallelism like the book of Psalms in the Bible. Their Christology is not orthodox as would be defined in the fourth century, but it expresses an emerging acceptance of the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor364"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor365"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor366"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor367"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor368"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor369"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor370"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor371"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor372"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor373"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor374"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page29",
      "title": "29"
    }
  }), _vm._v("divinity of Jesus and a primitive trinitarian formula. The following, from Ode 7, is a christological hymn, which shows the poetic style of early Asian Christian literature, both liturgical and homiletic.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("He became like me, that I might receive Him.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("In form He was considered like me, that I might put Him on.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("And I trembled not when I saw Him,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Because He was gracious to me.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("Like my nature He became, that I might understand Him.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("And like my form, that I might not turn away from Him.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("The Father of knowledge is the Word of knowledge.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("He who created wisdom is wiser than His works."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-017-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Other evidence of early Asian Christianity includes the record of Asian rulers confessing the faith, the earliest record of a church building, and later records of bishoprics that indicate extensive missionary activity during the first three centuries. We will look at each one of these.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("According to the late fourth-century Syriac work The Doctrine of Addai,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-016-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" and confirmed by semiconverted court official Bardaisan in "), _c('i', [_vm._v("The Book of the Laws of Countries")]), _vm._v(","), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-015-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('i'), _vm._v("King Abgar V of Osrhoene (capital city, Edessa) came to faith soon after the death and resurrection of Jesus Christ. The Doctrine of Addai claims that King Abgar sent a delegation to bring the miracle worker Jesus of Nazareth to Edessa to cure him of his leprosy. A letter dictated by Jesus is recorded stating that Jesus was very busy, but after he returns to his Father, he will send a disciple to bring healing. Such an early royal conversion, plus the remarkable claims that Jesus sent a letter to the king and that the emissary Hanan drew a picture of Jesus and brought it back to Abgar, are unlikely. What is much more likely, or even certain, is that the later Abgar VIII (177–212), who ruled during the time of Bardaisan (154–222), came to faith and led his nation to follow Jesus of Nazareth. It is recorded in the Chronicles of Edessa that the church of the Christians was destroyed by "), _c('a', {
    attrs: {
      "id": "_idTextAnchor375"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor376"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor377"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor378"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor379"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor380"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page30",
      "title": "30"
    }
  }), _vm._v("a huge flood in 201."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-014-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" Christians were thus worshiping publicly, in all likelihood with the support of the government since Bardaisan was a court official and his "), _c('i', [_vm._v("Book of the Laws of Countries")]), _vm._v(" was a type of apologetic for the faith as he understood it.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Bardaisan’s theology as expressed in the "), _c('i', [_vm._v("The Book of the Laws of Countries")]), _vm._v(" is a unique insight into how early “royal theology” was developing in Asia and, at the same time, it is a window into cultural practices of second-century western Asia and eastern Europe. Clearly with little outside guidance, Bardaisan seemed to be giving an apologetic for the Christian faith that seemed reasonable to him, while comparing Christian belief and practice with other cultural practices. Expressed as a dialogue, Bardaisan answers questions from his interlocutor, Avida, about God and the practices of various cultures; then, in the middle of the dialogue, there is a fascinating paragraph on what Christians do and what they believe. Positively speaking, Christians in all cultures (“nations”) worship on the first day of the week, fast, attend to the reading of sacred texts, and are called by the name of their sovereign: "), _c('i', [_vm._v("Christ")]), _vm._v("ians. Negatively speaking, “we” Christians do not follow many of the customs of the cultures in which we live.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The brethren who are in Gaul do not take males "), _c('i', [_vm._v("for wives")]), _vm._v(", nor those who are in Parthia two wives; nor do those who are in Judæa circumcise themselves; nor do our sisters who are among the Geli consort with strangers; nor do those brethren who are in Persia take their daughters for wives"), _c('i', [_vm._v(";")]), _vm._v(" nor do those who are in Media abandon their dead, or bury them alive, or give them as food to the dogs; nor do those who are in Edessa kill their wives or their sisters when they commit impurity, but they withdraw from them, and give them over to the judgment of God; nor do those who are in Hatra stone thieves to death; but, wherever they are, and in whatever place they are found, the laws of the several countries do not hinder them from obeying the law of their Sovereign, Christ; nor does the Fate of the celestial Governors compel them to make use of things which they regard as impure."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-013-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Fate, a very strong Asian astrological concept, still had power for Bardaisan, but not final authority in a person’s life. This was a theology not concerned "), _c('a', {
    attrs: {
      "id": "_idTextAnchor381"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor382"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor383"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor384"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor385"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor386"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor387"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor388"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor389"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor390"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor391"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page31",
      "title": "31"
    }
  }), _vm._v("with christological or trinitarian formulations, but with defending the universality and missionary nature of this new Asian religion.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Another small kingdom on the border between the Roman and Persian empires that accepted the faith of Christians was Armenia. Tradition has it that the missionary Addai, mentioned above, traveled in the region as the first to bring the teachings of Christ to villages in Armenia. By the time of the national conversion under the King Tiridates III circa 310, many of the villages were following Christian teachings with Syriac texts from Syrian regions of the Roman Empire. Credit for the conversion of the king and the nation usually is given to Gregory the Illuminator (ca. 240–332). The Armenian culture was soon transformed by the immediate translation of biblical and extrabiblical texts into Armenian. Armenian culture adopted Christian teachings and worship thoroughly and unlike any other Asian culture to the present day.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("A third nation that received Christianity as its national religion in Asia in this early period was Georgia. Although tradition awards Georgia as the missionary field of the apostle Andrew, there is no direct evidence that he established churches by the early second century. However, Christian communities were common by the third century in eastern Georgia;"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-012-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" through the work of Georgian apostolic monks the faith spread, and in 337 King Mirian III (aka Mihran; 284–361) came to faith. Georgian Christianity, like Armenian, quickly became part of the fabric of the culture through the development of a Georgian script and the translation of the Bible and other sacred texts within the first century of the king’s conversion. Not until the tenth century did theological and ecclesial uniformity develop in Georgia; diversity of beliefs and practices built around the Georgian Bible marked the first half-millennium of Georgian Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Although the earliest Asian Christianity outside the Roman Empire was diverse in language and cultural expressions, it was led by the Syrian forms and teachings and by the Syriac language."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-011-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" Thus, most of the early Asian Christian writings were more biblical and allegorical and less philosophical "), _c('a', {
    attrs: {
      "id": "_idTextAnchor392"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor393"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor394"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor395"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor396"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor397"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor398"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor399"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor400"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page32",
      "title": "32"
    }
  }), _vm._v("than what developed in the Hellenistic world. Syrian Christianity was also ascetic and monastic in expression, more than in other regions. This asceticism, however, shaped the Asian church to be strongly missionary and, ironically, to engage social issues and eventually to become the seedbed of both ecclesial and social leaders. Syrian missionary monasticism left its formative character on the church in Armenia, Georgia, Osrhoene, central Asia, India, and even to China. Monastic life was both missionary and scholarly, leaving behind a great treasure trove of early Asian Christian literature: biblical, spiritual, allegorical, and poetic."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-010-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_16"
    }
  }, [_vm._v("India")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Although there is no definitive proof of when Christianity first arrived in India, it is accepted among most Indian Christians that the apostle Thomas first brought Christianity at the end of the first or beginning of the second century. This is not impossible, because we know that trade, by both land and sea, was common between the West and south Asia in the early centuries of the Common Era. However, there is no reliable documentary evidence for the arrival of the first Christians or the first Christian missionaries in India. The apocryphal Acts of Judas Thomas, written in Syriac and dated to the early third century, tells how the apostles, after Jesus’ ascension, divided up the world to evangelize all the nations, and Thomas was awarded India."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-009-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" Unwilling to go, he was sold as a slave to a merchant going to India, whereupon he worked for King Gundaphar (Gundaphorus). In India, Thomas led people to faith and he cared for the poor; according to this account, he performed miracles of healing, raising from the dead, and exorcism, and he preached to bring about conversion. The form of Christian life Thomas endorses in this book is very ascetic or world denying. It reflects more from the Syrian Christian communities than the teachings of the apostles found in Scripture. However, there may very well be elements of truth at the core, for there was a King Gundaphar in India (in the north, however, not along the southern coast), and the type of resistance to Thomas does reflect the forms of persecution that Christians encountered from Hindus in India.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor401"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor402"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor403"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor404"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor405"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor406"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor407"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor408"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor409"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor410"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor411"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor412"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor413"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page33",
      "title": "33"
    }
  }), _vm._v("According to the historian Eusebius, it was not Thomas, but another apostle, Bartholomew, who first came to India. Eusebius, as well as Jerome, refers to the story told by the Egyptian theologian Pantaenus when he returned from a visit to India in the second century. Pantaenus went to help the persecuted Indian Christians after an Indian delegation came to Alexandria. His visit was sometime in the last two decades of the second century. This story, which has much more history to it than the Thomas legend, reveals that a robust witnessing community existed in south India by the 170s. How they got there, and whether Thomas or Bartholomew was the evangelist, we may never know. We do know that these Christian communities, mostly along the southern coasts (both the southeast and southwest coasts), have existed since the second century, and they suffered persecution from Hindus in the early centuries. All traditions (Greek and Syriac, as well as Indian) agree with this.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_17"
    }
  }, [_vm._v("Early Theologies and Theologians in Asia")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("As we noted above, the earliest Christian theological writings were translations of Scripture (in Syriac, Armenian, and Georgian), and early liturgical writings such as the Odes of Solomon. Bardaisan represents the earliest attempts at a royal apologetic, with all the mixed motives and understandings involved in such an enterprise. The earliest Asian Christian literature and the richest literature for the first thousand years was in Syriac, and it was written between Antioch in the west and Persia and India to the east. The first major theologians from Persia would have to be Tatian (110–180), Aphrahat the Sage (writing 325–345), and Ephrem the Syrian (ca. 306–373). In the life and thought of Tatian, we see the cultural theological trends from Asia and from the Mediterranean. Tatian came from Mesopotamia but studied in Athens and traveled to Rome and even met Justin Martyr. What Tatian experienced in the ancient scholarly tradition in the Hellenistic world was far beyond what he had seen in Persia. It is likely that he was converted during his travels (probably in his study under Justin in Rome), and then he returned to Persia to establish a school of his own. The school that he established was very ascetic in its Christian life, highly critical of Western religion (as seen in his "), _c('i', [_vm._v("Oration to the Greeks")]), _vm._v("), and focused on the life of Jesus as viewed through a single Gospel narrative: the "), _c('i', [_vm._v("Diatessaron. ")]), _vm._v("The "), _c('i', [_vm._v("Diatessaron")]), _vm._v(", probably composed by Tatian in Syriac (and immediately translated into Greek, or vice versa) became the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor414"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor415"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor416"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor417"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor418"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor419"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor420"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor421"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page34",
      "title": "34"
    }
  }), _vm._v("standard life of Jesus for over two centuries in the Syriac-speaking world. Later, Ephrem of Edessa would write a commentary on the "), _c('i', [_vm._v("Diatessaron")]), _vm._v(". Tatian, the first real Asian theologian, was proud of his Asian heritage, although his scholarly abilities all came from his academic sojourn in the West.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Unlike Tatian, Aphrahat remained in Persian territory. Aphrahat, “the Persian Sage,” is known solely for his "), _c('i', [_vm._v("Demonstrations")]), _vm._v(", written between 336 and 345, a series of twenty-three short writings that give us one of the only windows into early fourth-century Persian Christianity. Little is known of Aphrahat’s life except that he was most likely a member of the Sons of the Covenant, a basic monastic form of Asian Christianity. The first ten demonstrations or treatises prescribe for the reader how to live the Christian (not just ascetic) life. It is like a guidebook for the Christian life. Other treatises are actually letters, including a letter to a synod of bishops, and the final nine deal with relations with Jews. Aphrahat’s context was very different from those of the Christians in the Roman Empire. His theological concerns were to promote a spiritual and practical theology that would help Christians to live faithfully and would, at the same time, correct the teachings of the Jews. His was an independent Christian tradition, with no knowledge of the christological or trinitarian controversies of the West. Persian Christianity, we see with Aphrahat, was an independent and vital tradition of Asian Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Ephrem, “the Harp of the Holy Spirit,” is the best known of all Syriac-writing theologians. He is recognized as a saint by both the Roman Catholic and Orthodox Churches for his holy writings and life. His writings more than any other in Asia shaped the theology, structure, liturgy, even hymnody of the Persian church. Orthodoxy was established as much by Ephrem as any other single author in Persian Christianity. His influence was great because of both the variety and the extent of his writings. Ordained only as a deacon, Ephrem was possibly a member of the Sons of the Covenant, like Aphrahat, which gave a sense of community Christian life to his writings. Born in Nisibis to a Christian family, Ephrem’s writings reflect the culturally and religiously pluralistic world of land between empires. His early writings were from Nisibis, where his teaching is identified as the founding of its famous school. Caught in the political events of his time, some of Ephrem’s writings come out of the period when Nisibis was under siege by the Persian emperor, Shapur II. Nisibis had been under the influence of Constantine’s "), _c('a', {
    attrs: {
      "id": "_idTextAnchor422"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor423"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor424"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor425"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor426"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor427"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor428"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor429"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor430"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor431"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor432"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor433"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor434"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page35",
      "title": "35"
    }
  }), _vm._v("Roman Empire, but by 337, the year of Constantine’s death, Shapur began to extend his borders to the west. At the same time, the persecution of Christians increased, including the requirement of paying a double tax. Bishops and priests were killed as Nisibis was under siege three times. Ephrem, in his "), _c('i', [_vm._v("Carmina Nisibena")]), _vm._v(", reflects on this history with theological adroitness. History, theology, poetry, and biblical symbolism coalesce in these writings.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Eventually Nisibis fell to the Persian emperor, but unlike earlier victories for Shapur, in this case he allowed the Christians to flee to the “Christian” West. Previously, he had executed most of the citizens and allowed others to be displaced deep into the Persian Empire. Ephrem’s last ten years were devoted to writing hymns and theology against the heresies of Manichaeism, the mixed theological teachings of Bardaisan, and against local deities (of which there were many). Cosmopolitan Edessa was given theological leadership under Ephrem. To battle many of the heresies, Ephrem gathered female choirs and wrote for the choirs to sing of the divinity of Jesus, the joys of chastity, and the truth of the Trinity. Consistent with his theology and life, Saint Ephrem died caring for the sick during a period of plague in 373.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Christianity was less ordered and more diverse in Asia outside the Roman Empire. Christological controversies in the West were settled within the context of a Christian empire that provided the structure (if not pressure) for the church to find its own unity regarding wording (theology) and bishoprics (order). The Asian church did not have this pressure, but it did have another type, the growing and changing persecution from nonsympathetic rulers. Asian Christianity collected the rejected theologies and theologians from the West and (after the rise of the Sasanians) it also struggled for its very existence under Sasanian and later Arab rulers. The early controversies in the West (mostly Arianism) were of no consequence in the East, but when Nestorius and his theology were condemned by the Council of Ephesus (431), many of his followers fled to the East, eventually becoming a mainstream of east Syrian orthodoxy, centered in the capital city of Selucia-Ctesiphon (later Baghdad). After the Miaphysite (Monophysite) controversy led to the Council of Chalcedon in 451, those who held on to the belief in the single nature in Christ ("), _c('i', [_vm._v("mono")]), _vm._v("-"), _c('i', [_vm._v("physis")]), _vm._v(") were exiled and became the west Syrian theological tradition. It was the west Syrian tradition that most identified with Egypt and Ethiopia. The east "), _c('a', {
    attrs: {
      "id": "_idTextAnchor435"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor436"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor437"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor438"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor439"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor440"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page36",
      "title": "36"
    }
  }), _vm._v("Syrian, Diophysite theology became the theology of Asia that spread to the East. They held their own councils, beginning with the Synod of Isaac in 410. Most of these early Asian councils were called to reorganize the church after persecution; little theological discussion ensued. The second synod, in 420, also was called to bring about greater order and prevent schism, but the third synod in 424 is more memorable because it made a clear break with the church in the West. This Synod of Dadyeshu (424) claimed that the patriarch in Seleucia-Ctesiphon was equal to any patriarch in the West, giving the Asian church a de jure independence it had exhibited de facto for most of its life. From this point on, bishops in central Asia, India, and even China would be commissioned from the Persian capital.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_18"
    }
  }, [_vm._v("Religious Pressures and Persecutions: Zoroastrian and Muslim")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The advent of the Sasanian Dynasty in Persia around 225 brought with it a revival of the sixth-century BCE religion of Zoroastrianism. A dualistic faith with two creator gods—Ahura-Mazda, who creates what is good, and Ahriman, who creates a parallel evil creation—Zoroastrian life and worldview was closer to Judaism and Christianity than any of the local fertility or astrological faiths of Persia. The first ruler of the Sasanian Dynasty, Ardashir I (r. 225–240), appointed a religious adviser or "), _c('i', [_vm._v("mobed")]), _vm._v(" (magi) named Tansar, who revived the practice of regional sacred fires and purity laws. Purity, or separation from what is profane or polluted (created by Ahriman), is integral to the Zoroastrian faith. This is where major cultural conflicts occurred. Asian Christianity tended to be ascetic, but Zoroastrianism viewed “bounty” (many children, crops, and cattle) as a sign of sacredness. Ahura-Mazda’s blessing was understood to be in a land that produced bounty. When Christians refused to marry or to have children, or when Christians buried their dead in the ground (polluting the land), they were unwittingly taking the side of the evil god, Ahriman. Later "), _c('i', [_vm._v("mobeds")]), _vm._v(" counseled the shahs to give stronger adherence to Zoroastrian teaching, and this inevitably brought greater persecution on the Christians.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Beginning 339, soon after the death of Constantine, persecution of Christians became extreme. Christians were to pay a double tax and were not allowed to build churches or to repair their existing ones. They were not allowed "), _c('a', {
    attrs: {
      "id": "_idTextAnchor441"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor442"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor443"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor444"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor445"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor446"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor447"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor448"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor449"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page37",
      "title": "37"
    }
  }), _vm._v("to evangelize or marry outside their community, effectively establishing Christians as a "), _c('i', [_vm._v("millet")]), _vm._v(", or isolated ghetto community. The vitality of Christianity, its missionary outreach, was cut off. Many bishops and patriarchs, up to the time of the Arab invasions, were killed. For example, in 344 Bishop Simon (Bar-Sabba’e) of Seleucia-Ctesiphon, who refused to collect the double tax and then refused a bribe from the shah, was killed, but only after watching five other of his bishops and one hundred priests beheaded. This was his last sight before he himself was beheaded.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This persecution was precipitated because of the close cooperation between shah and "), _c('i', [_vm._v("mobed")]), _vm._v(", but other persecution was more internal to the church. We mentioned above divisions in the church caused by Western controversies. Deep in Persia, another theological controversy began as a mixture of Jewish and Christian along with Zoroastrian teachings, with some additional elements of Hindu and Buddhist teachings. Founded by the prophet Mani, Manichaeism was a dualistic religion. What Manichaeism inherited most from Christianity was its missionary zeal and global vision. It was first established in India and then spread back to Mani’s homeland of Persia, and eventually with missionary enthusiasm spread within the ranks of the Roman army and to the east along the Silk Road to the Pacific. Manichaean writings are often hard to distinguish from Christian writings because of the allegorical images of light and dark and their missionary themes. Mani claimed to be a disciple of Jesus and of Paul, but his religion was much more dualistic, denigrating the physical world and seeking through ascetic discipline to subdue the flesh, so that the inner divine light could break free. Many Christians were entrapped in Manichaean-believing communities, not knowing the difference between this and the faith of Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The last religious encounter of Asian Christians was the one that prevented a possible revival of Christianity during a period when the Sasanian Empire was in decline in the seventh century. Arab Muslim invasions swept through a weak Persian Empire and by 637 had conquered Seleucia-Ctesiphon. The fall of the enemy of the Christians was seen to be a Christian victory, and for a season this was the case. The Arab caliphs needed help in ruling this new Persian Empire, and they found the Christians the best-educated and most trusted citizens. Christians were hopeful that Muslims would become more centered on Christ. Muslims were "), _c('a', {
    attrs: {
      "id": "_idTextAnchor450"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor451"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor452"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor453"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor454"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page38",
      "title": "38"
    }
  }), _vm._v("hopeful that Christians would follow their lead in renewing monotheistic life. Both were disappointed. In the early years Persian Christians served as accountants, managers, and jailers, and, for their part, they were pleased to help fellow monotheists who had crushed their persecutors. Under the second caliph, ‘Umar I (r. 634–644), other religious minorities were protected, but at the same time this protection had its price. Non-Muslims were consigned to a "), _c('i', [_vm._v("dhimmi")]), _vm._v(", which was patterned after the "), _c('i', [_vm._v("millet")]), _vm._v(" communities of the Persians. In the seventh century, "), _c('i', [_vm._v("dhimmi")]), _vm._v(" existence had very few limitations for the Christian communities. However, by the first decades of the eighth century, Christians were socially ostracized by their prescribed dress, mode of transportation (they were required to ride sidesaddle on horses), paying increased land and personal taxes, and by restrictions placed on church repairs. Most of the persecution under Arab rule up to the end of the first millennium was social, financial, and psychological. There were not the massive killings as under the Zoroastrian rulers. However, slowly Persian Christianity decayed from within. Patriarchs were chosen or approved by caliphs, and often bribery secured ecclesiastical positions. With contact outside the Christian "), _c('i', [_vm._v("dhimmi ")]), _vm._v("so tightly controlled, the Christian community atrophied; it decayed from within more than being crushed from without. The Asian church under Islamic rulers only survived in ancient forms, worshiping in an ancient language. One of the great tragedies of the decline of Persian Christianity was that it also meant the loss of a base for ongoing missionary work to the East.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_19"
    }
  }, [_vm._v("Earliest Chinese Christianity")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Persian monks who arrived in the Chinese capital of Xian (Chang-an) in 635 explained to Emperor Tai Zong that they had come to propagate the “Luminous Religion,” or the religion of light. In these early years of the Tang Dynasty, emperors were open to new knowledge and to trade with the non-Chinese world. Tai Zong encouraged all knowledge from afar: Buddhist, Manichean, and Christian. In 635 he issued an edict allowing the propagation of Christianity, and he also gave room for monks to translate their texts on the grounds of the royal palace. A church was soon built in Xian, and monks were dispersed throughout the expanding empire. Both the pull factor of the emperor’s thirst for knowledge and the push "), _c('a', {
    attrs: {
      "id": "_idTextAnchor455"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor456"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor457"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor458"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor459"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor460"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor461"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor462"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor463"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor464"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor465"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor466"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor467"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor468"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page39",
      "title": "39"
    }
  }), _vm._v("factor of the missionary zeal of Persian monks were involved in the rapid spread of Christianity along the Silk Road and throughout China.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Much has been made of the imprecise theology of earliest Chinese Christianity. These monks were east Syrian and thus Diophysite, and not orthodox by European standards. They did not translate the whole Bible; in fact we don’t have even one complete book of the Bible translated into Chinese from this early period (in contrast to Syria, Armenia, the Roman Empire, and Georgia). Finally, this earliest Chinese Christianity has been criticized for building monasteries and not churches. And so, the reasoning goes, what spread in China in the early period was not a healthy form of Christianity."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-008-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("However, this earliest movement of Christianity in China is far more complex and rich than has often been appreciated. Monastic religion was very appropriate in Asia, especially China, and this may have been reason for the early acceptance rather than cause of Christianity’s decline. Although we do not have record of books of the Bible being translated, it is clear that much was written about Jesus (“Jesus the Messiah Sutra,” ca. 638), almost in the pattern of Buddhist Jataka stories (stories of the former lives of the Buddah). Most of the writings in Chinese were apologetic in nature. We continue to find more Christian sutras into the twenty-first century, indicating there was more of a Christian movement in Tang China than we had realized. One of the strongest criticisms of early Chinese Christianity—that it was a syncretism with Daoism or Buddhism—can be seen as positive trait. Rather than bringing Persian forms of Christianity, Chinese forms were developing from the very beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As in all newly encountered cultures, it takes centuries for local theological lines to develop. In China, the church did not have the luxury of developing, for persecution began with the rise of Empress Wu Zetian (Wu Hao or Wu Zhou, 625–705) in the last decade of the seventh century. The empress selected another foreign religion, Buddhism, as the national faith for China, and thus persecution of Christians began in earnest in 691. Persecution lasted over two decades. Churches were then rebuilt, and there is evidence of much more translation, dialogue with other religions, and the spread of monasteries. Once again, peace did not last for the church. By the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor469"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor470"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor471"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor472"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor473"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor474"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor475"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor476"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor477"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page40",
      "title": "40"
    }
  }), _vm._v("middle of the ninth century, persecution returned, and this time it did not abate. The persecution was expressed, beginning in the 840s, as a nationalistic revival of Chinese religious belief against all followers of foreign religions: Manicheans, Christians, Zoroastrians, and then Buddhists. Although some small Christian communities survived, and some forms of royal Christianity developed among the Mongol tribes,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-007-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" it is generally agreed that the extensive rejection of Christianity by Chinese rulers silenced Chinese Christianity. When envoys of Franciscans and Dominicans in the thirteenth and fourteenth centuries arrived in China, they confirmed this assumption.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In 1623, workers near present-day Xian unearthed a nine-foot stone monument—stele—with writing in both Chinese and Syriac describing the first arrival of Christian missionaries to China in 635. This came as news to Christians in the West, indicating the eradication of the first wave of Chinese Christianity and even the loss of the memory of this important chapter in Christian history. The monument, commonly called the Nestorian Monument, is a public, even political, statement that tells the story of the coming of the first missionary monks led by Alopen the Persian. Erected in 781, the monument tells the history of the coming of the first missionaries from the West, explains a little about the theology of this new religion, and then describes a history that shows the value of this “luminous religion” for the Chinese Empire. At points the statement is clearly orthodox Christian, at other points sounding strangely Chinese (“Twenty-seven sacred books [the number in the New Testament] have been left, which disseminate intelligence by unfolding the original transforming principles . . .”). Much ink has been spilt over the meaning and purpose of the stele. What it does indicate is that Christianity had a public standing at the end of the eighth century in China, and Christians saw it as important to make a public statement in the pattern of Chinese cultural norms. In the history of Asian Christianity it is one of the most important reminders of the constantly changing fortunes of Christianity in Asia: one moment publicly proclaimed by royalty, the next crushed by that same class. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27449018","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/09ch2.vue
// module id = 78
// module chunks = 0